module.exports = __webpack_public_path__ + "static/media/76770.303467b4.png";